import { reactive, computed, toRefs } from 'vue'
import api from '../../v2/services/api'
import router from '../../v2/router/route'
import { SESSION_NAME } from '../../v2/constant/constantApp'
import { notify } from '../../v2/utilities/notif'

/**
 * STATE (singleton)
 */
const defaultProfile = () => ({
    name: "",
    email: "",
    phone: "",
    photo: "../public/photo/user.png",
    level:1,
    point:0,
    deposito:0,
    tax:"non",
    delivery: "Kirim"
})

const state = reactive({
    token: localStorage.getItem(SESSION_NAME),
    profile: defaultProfile(),
})

/**
 * GETTERS
 */
const isAuth = computed(() => {
    return typeof state.token === 'string' && state.token.length > 0
})

/**
 * ================================
 * ACTIONS
 * ================================
 */

function setToken(token) {

    state.token = token
    localStorage.setItem(SESSION_NAME, token)
}

function clearAuth() {

    state.token = null
    localStorage.removeItem(SESSION_NAME)
    
    Object.assign(state.profile, defaultProfile())
}

function setProfile(data) {
    Object.assign(state.profile, data)
}

function setSession(data) {
    const token = data?.token || data?.data?.token
    const profile = data?.profile || data?.data?.profile

    if (!token) {
        throw new Error('Token login tidak ditemukan.')
    }

    setToken(token)

    if (profile) {
        setProfile(profile)
    }
}

function setDeposit(data) {
    state.profile.deposito = data
}

async function login(payload) {
    try {
        const response = await api.post('login', payload)
        const {token, profile} = response.data
        setToken(token)
        setProfile(profile)

        return true
    } catch (error) {
        throw error
    }
}

async function loginGoogle(payload) {
    try {
        const response = await api.post('login-google', payload)
        const {token, profile} = response.data

        setToken(token)

        setProfile(profile)

        return true
    } catch (error) {
        throw error
    }
}

async function loginBiometric(payload) {
    setSession(payload)
    return true
}

function logout(message) {

    clearAuth()

    if (message) {
        notify(message)
    }

    router.replace({ name: 'login' })
}

/**
 * STORE EXPORT
 */
export function useAuthStore() {
    return {
        ...toRefs(state),
        isAuth,
        clearAuth,
        login,
        loginBiometric,
        setProfile,
        loginGoogle,
        logout,
        setDeposit
    }
}
